import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

const baseUrl = `${config.dev}/v2/reservations`;

export async function fetchReservationTables() {
  const response = await axios.get(`${baseUrl}/tables`, { headers: authHeaders() });
  return response.data;
}

export async function fetchNextReservationTableNumber() {
  const response = await axios.get(`${baseUrl}/tables/next-number`, {
    headers: authHeaders(),
  });
  return response.data?.tableNumber;
}

export async function createReservationTable(payload) {
  const response = await axios.post(`${baseUrl}/tables`, payload, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function updateReservationTable(id, payload) {
  const response = await axios.put(`${baseUrl}/tables/${id}`, payload, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function deleteReservationTable(id) {
  const response = await axios.delete(`${baseUrl}/tables/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function saveReservationLayout(tables) {
  const response = await axios.put(
    `${baseUrl}/layout`,
    { tables },
    { headers: authHeaders() }
  );
  return response.data;
}

export async function fetchReservationAvailability({ date, time, durationMinutes, partySize }) {
  const response = await axios.get(`${baseUrl}/availability`, {
    headers: authHeaders(),
    params: { date, time, durationMinutes, partySize },
  });
  return response.data;
}

export async function fetchReservations({
  date,
  from,
  to,
  archived = false,
  source,
  upcoming = false,
  all = false,
} = {}) {
  const response = await axios.get(`${baseUrl}/retrieve`, {
    headers: authHeaders(),
    params: {
      ...(date ? { date } : {}),
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
      ...(archived ? { archived: true } : {}),
      ...(source ? { source } : {}),
      ...(upcoming ? { upcoming: true } : {}),
      ...(all ? { all: true } : {}),
    },
  });
  return response.data;
}

export async function createReservation(payload) {
  const response = await axios.post(`${baseUrl}/create`, payload, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function updateReservation(id, payload) {
  const response = await axios.put(`${baseUrl}/update/${id}`, payload, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function deleteReservation(id) {
  const response = await axios.delete(`${baseUrl}/delete/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function updateReservationArchive(id, archived) {
  const response = await axios.put(
    `${baseUrl}/archive/${id}`,
    { archived },
    { headers: authHeaders() }
  );
  return response.data;
}
